export function setFromPage(state, payload) {
  state.fromPage = payload;
}

export function clearFromPage(state) {
  state.fromPage = '';
}

export function setFlowType(state, payload) {
  state.flowType = payload;
}

export function clearFlowType(state) {
  state.flowType = '';
}

export function setIsLoggingOff(state, payload) {
  state.isLoggingOff = payload;
}

export function setVerificationReceiver(state, payload) {
  state.verificationReceiver = payload;
}

export function clearVerificationReceiver(state) {
  state.verificationReceiver = undefined;
}

export function setRememberMe(state, payload) {
  state.rememberMe = payload;
}

export function clearRememberMe(state) {
  state.rememberMe = false;
}

export function setHasPhoneNumber(state, payload) {
  state.verificationInfo.hasPhoneNumber = payload;
}
export function clearHasPhoneNumber(state) {
  state.verificationInfo.hasPhoneNumber = undefined;
}

export function setHasEmailAddress(state, payload) {
  state.verificationInfo.hasEmailAddress = payload;
}
export function clearHasEmailAddress(state) {
  state.verificationInfo.hasEmailAddress = undefined;
}

export function setIsVerificationCodeNeeded(state, payload) {
  state.isVerificationCodeNeeded = payload;
}

export function setEmail(state, payload) {
  state.email = payload;
}

export function clearEmail(state) {
  state.email = '';
}

export function setAccountDetails(state, payload) {
  state.accountDetails = payload;
}

export function clearAccountDetails(state) {
  state.accountDetails = false;
}

export function setUsernameAlreadyExists(state, payload) {
  state.accountDetails = state.accountDetails.setUsernameAlreadyExists(payload);
}

export function setHasIdinFailed(state, payload) {
  state.hasIdinFailed = payload;
}

export function clearHasIdinFailed(state) {
  state.hasIdinFailed = false;
}

export function setIdinFailureMessage(state, payload) {
  state.idinFailureMessage = payload;
}

export function clearIdinFailureMessage(state) {
  state.idinFailureMessage = '';
}

/**
 * Alert of which the contents are visible to the end-user.
 */
export function setHasIdinFailureInstructions(state, payload) {
  state.hasIdinFailureInstructions = payload;
}

export function setIdinBankOptions(state, payload) {
  state.idinBankOptions = payload;
}
export function setBankOptions(state, payload) {
  state.bankOptions = payload;
}

export function setIsAccountTemporaryBlocked(state, payload) {
  state.isAccountTemporaryBlocked = payload;
}
